import { render, staticRenderFns } from "./journey.vue?vue&type=template&id=2eea0e6d&scoped=true"
import script from "./journey.vue?vue&type=script&lang=js"
export * from "./journey.vue?vue&type=script&lang=js"
import style0 from "./journey.vue?vue&type=style&index=0&id=2eea0e6d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eea0e6d",
  null
  
)

export default component.exports